import Vue from 'vue';
import ElementUI from 'element-ui';
import './element-variables.scss'

Vue.use(ElementUI)